if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener("change", (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
            {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            }
          );
        });

        // Run padding logic here after rendering
        this.applyPaddingForDoubleWordSwatches();
        this.initColorGroupTabs();
      }

      initColorGroupTabs() {
        this.querySelectorAll("[data-color-groups]").forEach((fieldset) => {
          fieldset.querySelectorAll("[data-color-group-tab]").forEach((tab) => {
            tab.addEventListener("click", (event) => {
              event.preventDefault();
              const group = tab.dataset.colorGroupTab;
              if (!group || fieldset.dataset.activeColorGroup === group) return;
              this.switchColorGroup(fieldset, group);
            });
          });
        });
      }

      switchColorGroup(fieldset, group) {
        fieldset.dataset.activeColorGroup = group;

        fieldset.querySelectorAll("[data-color-group-tab]").forEach((tab) => {
          const isActive = tab.dataset.colorGroupTab === group;
          tab.classList.toggle("is-active", isActive);
          tab.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        fieldset.querySelectorAll("input[data-color-group]").forEach((input) => {
          input.classList.toggle(
            "color-group-hidden",
            input.dataset.colorGroup !== group
          );
        });

        const firstAvailable = Array.from(
          fieldset.querySelectorAll(`input[data-color-group="${group}"]`)
        ).find(
          (input) =>
            !input.disabled &&
            !input.classList.contains("disabled") &&
            !input.classList.contains("visually-disabled")
        );

        if (firstAvailable && !firstAvailable.checked) {
          firstAvailable.checked = true;
          firstAvailable.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      applyPaddingForDoubleWordSwatches() {
        const swatchFieldsets = this.querySelectorAll(
          "fieldset[data-after-content]:not([data-color-groups])"
        );

        swatchFieldsets.forEach((fieldset) => {
          const content = fieldset.getAttribute("data-after-content") || "";
          const wordCount = content.trim().split(/\s+/).filter(Boolean).length;
          fieldset.style.paddingRight = wordCount >= 2 ? "112px" : "";
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          target.selectedOptions[0].setAttribute("selected", "selected");

          const swatchValue =
            target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value] > .swatch");
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              "unset"
            );
            selectedDropdownSwatchValue.classList.add("swatch--unavailable");
          }

          selectedDropdownSwatchValue.style.setProperty(
            "--swatch-focal-point",
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
          );
        } else if (tagName === "INPUT" && target.type === "radio") {
          const inputWrapper = target.closest(".product-form__input");
          if (!inputWrapper) return;

          const selectedSwatchValue = inputWrapper.querySelector(
            "[data-selected-value]"
          );
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;

          const selectedSwatchLabel = inputWrapper.querySelector(
            "[data-selected-swatch-value]"
          );
          if (selectedSwatchLabel) selectedSwatchLabel.textContent = value;

          if (inputWrapper.hasAttribute("data-after-content")) {
            inputWrapper.setAttribute("data-after-content", value);
            this.applyPaddingForDoubleWordSwatches();
          }
        }
      }
    }
  );
}
